/*保存，设置页面滚动位置*/

export default {
  methods: {
    savePageScrollPosition(scrollClassName) {
       this.$route.meta['scrollTop'+'_'+scrollClassName] = document.querySelector('.' + scrollClassName).scrollTop + '&timestamps=' + Date.now();
    },
    setPageScrollPosition(scrollClassName, position) {
      if (position == 0) {
        if (document.querySelector('.' + scrollClassName)) {
          document.querySelector('.' + scrollClassName).scrollTop = position;
        }
        return;
      }
      if (this.$route.meta['scrollTop'+'_'+scrollClassName]) {
        this.$root.$nextTick(() => {
          let [scrollTop, timestamps] = (this.$route.meta['scrollTop'+'_'+scrollClassName]).split('&timestamps=');
          if(parseInt(timestamps) - Date.now() < 5 * 60 * 1000){
            if (document.querySelector('.' + scrollClassName)) {
              document.querySelector('.' + scrollClassName).scrollTop = scrollTop;
            } 
          }
        });
      }
    },
  }
}